
<button
    class="Button"
    tabindex="0"
    :disabled="isDisabled"
    :data-testid="testId"
    :class="[
        `is-${variant}`,
        { 'is-disabled': isDisabled },
        { 'has-button': hasIcon },
        { 'is-large': size === 'large' },
        { 'is-small': size === 'small' },
        { 'is-loading': isLoading },
        { [`is-${color}`]: color },
    ]"
    :style="style"
    @click="handleClick"
>
    <div class="Button-Wrapper">
        <Spinner v-if="isLoading" />
        <span v-if="hasIcon || icon" class="IconBefore" ref="iconBefore">
            <slot name="iconBefore">
                <i v-if="icon" :class="`ri-${icon}-line`"></i>
            </slot>
        </span>
        <span class="Label">
            <span v-if="value">{{ value }}</span>
            <slot></slot>
        </span>
    </div>
</button>
